import { Component, inject, OnInit } from '@angular/core';
import { of, Subject } from 'rxjs';
import { catchError, mergeMap, tap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesPanelService } from '@app/shared/services/messages.service';
import { DialogService } from '@app/shared/services/dialog.service';
import { BannerMessage } from '../messages.model';
import { AlertModule } from 'ngx-bootstrap/alert';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'vp-active-messages',
  templateUrl: './active-messages.component.html',
  styleUrls: ['./active-messages.component.css'],
  imports: [
    AlertModule,
    AsyncPipe
  ]
})
export class ActiveMessagesComponent implements OnInit {
  private messagesPanelService = inject(MessagesPanelService);
  private dialogService = inject(DialogService);
  
  activeMessages$ = this.messagesPanelService.activeMessages$;
  private readMessageSubject = new Subject<number>();

  markMessageAsRead = (message: BannerMessage) => this.readMessageSubject.next(message.id);

  ngOnInit() {
    this.readMessageSubject.pipe(
      mergeMap(id => this.readMessage(id))
    ).subscribe();
  }

  readMessage(id: number) {
    return this.messagesPanelService.readMessage(id).pipe(
      tap(() => {
        this.messagesPanelService.refreshActiveMessages();
      }),
      catchError((response: HttpErrorResponse) => {
        this.dialogService.showMessageDialog(
          'Error',
          `Something went terribly wrong! Status: ${response.status}`
        );
        return of(null);
      })
    );
  }
}
